import React, { FC, useEffect, PropsWithChildren } from "react";
import "./ModalDialog.scss";

export interface ModalDialogProps {
    onClose(): void;
}

export const ModalDialog: FC<PropsWithChildren<ModalDialogProps>> = props => {

    useEffect(() => {
        document.body.classList.add("xapp-search-opened");

        return () => {
            document.body.classList.remove("xapp-search-opened");
        };
    }, []);

    // return (
    //     <div className="xapp-search-modal">
    //         {/* <div className="xapp-search-modal__backdrop" onClick={props.onClose} /> */}
    //         <div className="xapp-search-modal__body">
    //             {props.children}
    //         </div>
    //     </div>
    // );

    return <div className="xapp-search-modal__body">{props.children}</div>;
}